// extracted by mini-css-extract-plugin
export default {"panel":"styles_panel_d4f_8","slackButton":"styles_slackButton_ZZL_J","dragPanel":"styles_dragPanel_o_ygI","content":"styles_content_Uwby2"};